import React, { useRef, useState } from 'react'
import { DropDownMenu, FlashMessage, GlobalLoader } from '@reactiveonline/reactive_admin_shared-packages'
import CreateTenantModal from '../shared/CreateTenantModal'
import ImportAccountsModal from '../shared/ImportAccountsModal'
import GlobalImports from '../shared/GlobalImports'

export default function Index({
  appProps, admin, canImportAccounts, createRegistrationsPath, countriesPath, getOrganizationsPath, getRegistrationDataPath, getAvailableFlavoursAndPackagesPath,
  brandWebsiteUrl, helpCenterUrl, registrationsPath, supportPhoneUrl,
  promoArea, importAccountsPath
}) {
  const [showCreateTenantModal, setShowCreateTenantModal] = useState(false)
  const [showImportModal, setShowImportModal] = useState(false)
  const [availableOrganizationData, setAvailableOrganizationData] = useState([])
  const [countries, setCountries] = useState([])
  const [loading, setLoading] = useState(false)

  const flashMessageRef = useRef(null)

  const dropdownActions = [
    {
      icon: 'fa-plus',
      action: () => handleCreateTenantClick(),
      text: Partners.translations.create_tenant,
      permissions: true
    },
    {
      icon: 'fa-upload',
      action: () => setShowImportModal(true),
      text: Partners.translations.tenant.import_from_excel,
      permissions: canImportAccounts
    }
  ]

  const closeCreateTenantModal = () => {
    setShowCreateTenantModal(false)
  }

  const handleCreateTenantClick = () => {
    if (availableOrganizationData.length === 0) {
      setLoading(true)

      getCountries()

      Rails.ajax({
        type: 'GET',
        url: `${ getRegistrationDataPath }?admin_id=${ admin.id }`,
        dataType: 'json',
        success: res => {
          setAvailableOrganizationData(res.items)
          setLoading(false)
          setShowCreateTenantModal(true)
        }
      })
    } else {
      setShowCreateTenantModal(true)
    }
  }

  const getCountries = () => {
    Rails.ajax({
      type: 'GET',
      url: countriesPath,
      dataType: 'json',
      success: res => setCountries(res.availableCountries)
    })
  }

  return (
    <>
      <div className='page-wrapper-header'>
        <div style={{ width: '100%' }}>
          <div className='flex-box items-center content-space-between flex-wrap' style={{ gap: 20 }}>
            <div className='page-header'>
              <i className={ `fa-light fa-home` }/>
              <div className='flex-box flex-column'>
                <h1 className='page-header-title'>
                  { Partners.translations.home.home_page}
                </h1>
                <div className='m-t-5'>
                  { admin.name || admin.email }
                </div>
              </div>
            </div>

            <DropDownMenu
              items={ dropdownActions }
              title={ ReactiveCore.translations.dropMenuAction }
            />
          </div>
        </div>
      </div>

      <div className='card'>
        <div className='card-content'>
          <div className='card-title m-b-20'>
            { Partners.translations.home.useful_links }
          </div>

          <div className='card-body'>
            <div className='flex-box flex-column'>
              <div style={{ padding: '20px 0', borderBottom: '1px solid #ddd' }}>
                <a
                  href={ helpCenterUrl }
                  target='_blank'
                  className='flex-box items-center content-space-between'
                >
                  <div>
                    <i className='fa fa-circle-info p-r-20' />
                    { Partners.translations.home.help_center }
                  </div>
                  <div>
                    <i className='fa fa-chevron-right' />
                  </div>
                </a>
              </div>
            </div>

            <div style={{ padding: '20px 0', borderBottom: '1px solid #ddd' }}>
              <a
                href={ `tel:${ supportPhoneUrl }` }
                target='_blank'
                className='flex-box items-center content-space-between'
              >
                <div>
                  <i className='fa fa-phone p-r-20' />
                  { Partners.translations.home.support_phone }
                </div>
                <div>
                  <i className='fa fa-chevron-right' />
                </div>
              </a>
            </div>

            <div style={{ padding: '20px 0', borderBottom: '1px solid #ddd' }}>
              <a
                href={ brandWebsiteUrl }
                target='_blank'
                className='flex-box items-center content-space-between'
              >
                <div>
                  <i className='fa fa-desktop p-r-20' />
                  { Partners.translations.home.brand_website }
                </div>
                <div>
                  <i className='fa fa-chevron-right' />
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>

      { promoArea &&
        <div dangerouslySetInnerHTML={{ __html: promoArea  }} />
      }

      { showCreateTenantModal &&
        <CreateTenantModal
          admin={ admin }
          availableOrganizationData={ availableOrganizationData }
          closeModal={ closeCreateTenantModal }
          createRegistrationsPath={ createRegistrationsPath }
          countries={ countries }
          getAvailableFlavoursAndPackagesPath={ getAvailableFlavoursAndPackagesPath }
        />
      }

      { showImportModal &&
        <ImportAccountsModal
          adminRole={ admin.role }
          closeModal={ () => setShowImportModal(false) }
          getOrganizationsPath={ getOrganizationsPath }
          registrationsPath={ registrationsPath }
          loading={ loading }
          setLoading={ setLoading }
          importAccountsPath={ importAccountsPath }
        />
      }

      { loading && <GlobalLoader fullPage /> }

      <FlashMessage ref={ flashMessageRef } />
      <GlobalImports appProps={ appProps } />
    </>
  )
}
